import React from 'react'
import Breadcrumb from '../components/Breadcrumb'
import DashBoardLayerOne from '../components/DashBoardLayerOne'

const HomePageOne = () => {
  return (
    <>

    
    <Breadcrumb title={"Insights"}/>

    <DashBoardLayerOne/>
     
    
    </>
  )
}

export default HomePageOne